<template>
    <v-card flat class="score-trans ma-1" :height="getChartHeight()">
        <v-container fluid>
            <v-row dense>
                <v-col cols="12">
                    <v-card flat class="score-trans mt-2">
                        <h3>Bookings</h3>
                        <h5>Over the last 14 days, this year and in same period of the previous year</h5>
                    </v-card>
                </v-col>
            </v-row>
            <v-row dense>
                <v-col cols="12">
                    <v-card flat fluid class="score-trans" :height="getChartHeight() - chart_correction">
                        <canvas id="bookings" height="300" style="width:100%;"></canvas>
                    </v-card>    
                </v-col>
            </v-row>
        </v-container>
    </v-card>
</template>

<script>

    import mxchart from '@/components/js/charts/bookings_chart_V3';
    import mxscreensize from '@/components/js/screensize';

    import { Chart, registerables } from 'chart.js'
    Chart.register(...registerables)    

    export default {
        props: {
            height_correction: Number,
            chart_correction: Number,
        },           
        data() {
            return {
                bookingsTY: [],
                bookingsPY: [], 
                chart: null,
            }
        },
        created(){ // set up event bus listener here on created event
            this.load('load');
        },                    
        mixins:[mxchart, mxscreensize],
        methods:{
            getChartHeight(){
                if((((this.wInnerHeight - (typeof this.height_correction === 'undefined' ? 0 : this.height_correction)) / 5) * 2) < 200){
                   return (((this.wInnerWidth - (typeof this.height_correction === 'undefined' ? 0 : this.height_correction)) / 5) * 2);
                }
                return (((this.wInnerHeight - (typeof this.height_correction === 'undefined' ? 0 : this.height_correction)) / 5) * 2);
            },
            refreshChart(object){
                this.chart.data.labels = object.data.labels;
                let i = 0;
                this.chart.data.datasets.forEach((dataset) => {
                   dataset.data = object.data.datasets[i].data;
                   i++;
                });
                this.chart.options = object.options;
                this.chart.update();
            },            
            load(param){         
                console.log('(re) load right panel booking data', param);
                this.$axios
                    .post("ares/json/ares/syst/dashboard/getRecentBookingsv5.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getRecentBookings"
                    },
                    })
                    .then(res => {
                        if (res.data.error) {
                            console.log(res.data.error);
                        } else {
                            this.bookingsTY = res.data.getRecentBookingsThisYear;    
                            this.bookingsPY = res.data.getRecentBookingsPreviousYear;    
                            if(param ==='load'){
                                const ctx = this.$el.querySelector('#bookings').getContext('2d');
                                this.chart = new Chart(ctx, this.createBarData(this.bookingsTY, this.bookingsPY, "bar")); // horizontalBar, bar                                
                            } else {
                                this.refreshChart(this.createBarData(this.bookingsTY, this.bookingsPY, "bar"));
                            }
                        }
                    });
            },             
        }
    }
</script>

<style scoped>
    .score-trans {
        background: transparent !important;
    }
</style>